import React, { useState, useEffect } from 'react';
import { Tag, Tooltip } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import axios from 'axios';

const IPLocation = ({ ip }) => {
  const [location, setLocation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ip || ip === 'unknown' || ip === '127.0.0.1' || ip === 'localhost') {
      return;
    }

    const fetchLocation = async () => {
      setLoading(true);
      setError(null);

      try {
        // 使用免费的IP地址定位服务
        const response = await axios.get(`https://ipapi.co/${ip}/json/`, {
          timeout: 5000
        });

        if (response.data && response.data.city) {
          setLocation({
            country: response.data.country_name || '未知',
            region: response.data.region || '未知', 
            city: response.data.city || '未知',
            isp: response.data.org || '未知'
          });
        } else {
          // 备用服务：使用太平洋电脑网API（只支持中国IP）
          try {
            const backupResponse = await axios.get(`https://whois.pconline.com.cn/ipJson.jsp?ip=${ip}&json=true`, {
              timeout: 5000,
              responseType: 'text'
            });

            if (backupResponse.data) {
              const data = JSON.parse(backupResponse.data);
              if (data.pro && data.city) {
                setLocation({
                  country: '中国',
                  region: data.pro,
                  city: data.city,
                  isp: data.addr || '未知'
                });
              }
            }
          } catch (backupError) {
            console.warn('备用IP定位服务失败:', backupError);
            setError('无法获取位置信息');
          }
        }
      } catch (err) {
        console.warn('IP定位服务失败:', err);
        setError('定位失败');
      } finally {
        setLoading(false);
      }
    };

    fetchLocation();
  }, [ip]);

  if (loading) {
    return <Tag size="small" color="processing">定位中...</Tag>;
  }

  if (error || !location) {
    return <Tag size="small" color="default">位置未知</Tag>;
  }

  const locationText = `${location.city}, ${location.region}`;
  const tooltipContent = (
    <div>
      <div><strong>国家/地区：</strong> {location.country}</div>
      <div><strong>省份/州：</strong> {location.region}</div>
      <div><strong>城市：</strong> {location.city}</div>
      <div><strong>网络服务商：</strong> {location.isp}</div>
    </div>
  );

  return (
    <Tooltip title={tooltipContent} placement="top">
      <Tag 
        size="small" 
        color="blue" 
        icon={<EnvironmentOutlined />}
        style={{ cursor: 'pointer' }}
      >
        {locationText}
      </Tag>
    </Tooltip>
  );
};

export default IPLocation; 